<template>
    <div class="bg-white p-5" style="border: solid 1px grey;">
        <div>
            <h4>Bài tập về nhà lần 2 buổi {{ lesson_alias || lesson }}</h4>
        </div>
        <hr/>
        <div v-loading="loadingMarkHomework" class="modal-fillter-poin table">
            <div class="table-responsive overflow-auto mt-3">
                <table class="table" style="text-align: center;">
                    <thead>
                        <tr>
                            <th scope="col" class="min-w-100px">Họ và tên</th>
                            <th scope="col" class="min-w-100px">Mã học viên</th>
                            <th scope="col" class="min-w-100px">Số điện thoại</th>
                            <th scope="col" class="min-w-100px">Trạng thái</th>
                            <th scope="col" class="min-w-120px">Hình thức chấm</th>
                            <th scope="col" class="min-w-120px">Deadline nộp bài tập về nhà</th>
                            <th scope="col" class="text-center">Thời gian GV chấm bài lần 2</th>
                            <th scope="col" class="min-w-120px">Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        <HomeWorkV2 v-for="(item, index) in homeWorkList" :learning_schedule_id="learning_schedule_id"
                            :lessonNumber="lesson" @action-mark-homework="actionMarkHomework" :homeWork="item"
                            :key="index" @reopenHomework="reopenHomework" @resetHomework="openResetHomeworkDialog"></HomeWorkV2>
                    </tbody>
                </table>
            </div>
        </div>
        <ResetHomeworkMarkDialog
            :visible.sync="resetDialog"
            :student-name="resetHomeworkData.name"
            :loading="resetLoading"
            @confirm="submitResetHomework"
        />
        <div>
            <el-dialog :visible.sync="dialog" width="30%" class="responsive" title="Mở lại bài tập về nhà">
                <p>Chọn ngày Dealine nộp bài</p>
                <div class="">
                    <el-date-picker
                        v-model="dateTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="Chọn ngày Deadline nộp bài "
                        :picker-options="{disabledDate: (time) => disabledDate(time)}">

                    </el-date-picker>
                </div>
                <div class="mt-2" v-if="dateTime">
                    Deadline học viên cần nộp bài: 12h00 - {{ dateTime }}
                </div>
                <div class="d-flex d-flex flex-row-reverse">
                    <button type="button" class="btn btn-success ml-4" @click="submit()">
                        Xác nhận
                    </button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import HomeWorkV2 from './components/HomeWorkV2.vue';
import ResetHomeworkMarkDialog from './components/ResetHomeworkMarkDialog.vue';
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {ADMIN_HOMEWORK_V2, REOPEN_HOMEWORK, RESET_HOMEWORK_MARK_V2} from "@/core/services/store/course/classes.module";
import moment from "moment";

export default {
    components: {
        HomeWorkV2,
        ResetHomeworkMarkDialog,
    },
    data() {
        return {
            lesson: null,
            lesson_alias: null,
            classroom_id: null,
            learning_schedule_id: null,
            homeWorkList:[],
            loadingMarkHomework: false,
            dialog: false,
            dateTime: '',
            dataReopen: {},
            resetDialog: false,
            resetLoading: false,
            resetHomeworkData: {},
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Chi tiết lớp học", route: 'schedule-class' },
            { title: "Danh sách lớp học" }
        ]);
        this.lesson = this.$route.query.lesson
        this.lesson_alias = this.$route.query.lesson_alias
        this.classroom_id = this.$route.query.classroom_id
        this.learning_schedule_id = this.$route.query.learning_schedule_id
        this.getListHomework()
    },
    methods: {
        getListHomework() {
            this.loadingMarkHomework = true;
            return this.$store.dispatch(ADMIN_HOMEWORK_V2, {classroom_id:this.classroom_id,lesson:this.lesson,type:'homework'}).then((res) => {
                if (!res.error) {
                    this.homeWorkList = res.data;
                }
            }).catch((e) => {
                console.log(e, 'error')
            }).finally(() => {
                this.loadingMarkHomework = false;
            });
        },
        disabledDate(time) {
            return moment(time).isSameOrBefore(moment(), 'day');
        },
        submit()
        {
            let payload = {
                'class_id': this.classroom_id,
                'lesson': this.lesson,
                'deadline': this.dateTime,
                'type': this.dataReopen.type,
                'student_register_id': this.dataReopen.course_student_id
            };
            this.$store.dispatch(REOPEN_HOMEWORK, payload).then((res) => {
                this.dialog = false;
                this.$message({
                    type: 'success',
                    message: 'Mở chấm bài thành công!',
                    showClose: true
                });
            });
        },
        reopenHomework(value)
        {
            this.dataReopen = value;
            this.dialog = true;
        },
        openResetHomeworkDialog(homeWork) {
            this.resetHomeworkData = homeWork;
            this.resetDialog = true;
        },
        submitResetHomework() {
            if (!this.resetHomeworkData.test) {
                return;
            }

            this.resetLoading = true;
            this.$store.dispatch(RESET_HOMEWORK_MARK_V2, {
                overall_result_id: this.resetHomeworkData.test.overall_id
            }).then((res) => {
                if (res.error) {
                    this.$message({
                        type: 'error',
                        message: res.message || 'Reset kết quả chấm thất bại!',
                        showClose: true
                    });
                    return;
                }

                this.$message({
                    type: 'success',
                    message: 'Reset kết quả chấm thành công!',
                    showClose: true
                });
                return this.getListHomework().then(() => {
                    this.resetDialog = false;
                    this.resetHomeworkData = {};
                });
            }).catch((e) => {
                const message = e?.data?.message || 'Reset kết quả chấm thất bại!';
                this.$message({
                    type: 'error',
                    message,
                    showClose: true
                });
            }).finally(() => {
                this.resetLoading = false;
            });
        }
    },
}
</script>

<style lang="scss" scoped></style>
